import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const OTHER = "__other__";

// State + City dropdowns fed by the seeded locations table, with an "Other"
// option that reveals a free-text box so users can add a missing place.
export default function CityStatePicker({ state, city, onState, onCity, inputClass = "" }) {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [stateOther, setStateOther] = useState(false);
  const [cityOther, setCityOther] = useState(false);

  useEffect(() => {
    api.get("/locations/states").then(({ data }) => { setStates(data || []); setLoaded(true); }).catch(() => setLoaded(true));
  }, []);

  useEffect(() => {
    if (!state || stateOther) { setCities([]); return; }
    api.get("/locations/cities", { params: { state } }).then(({ data }) => setCities(data || [])).catch(() => setCities([]));
  }, [state, stateOther]);

  const cls = inputClass || "w-full border border-black/20 rounded px-3 py-2.5 text-sm outline-none focus:border-squire-jeans bg-white";

  if (loaded && states.length === 0) {
    return (
      <>
        <input data-testid="addr-state" value={state} onChange={(e) => onState(e.target.value)} placeholder="State" className={cls} />
        <input data-testid="addr-city" value={city} onChange={(e) => onCity(e.target.value)} placeholder="City" className={cls} />
      </>
    );
  }

  return (
    <>
      <div className="space-y-2">
        <select data-testid="addr-state" value={stateOther ? OTHER : state}
          onChange={(e) => {
            if (e.target.value === OTHER) { setStateOther(true); onState(""); onCity(""); setCityOther(true); }
            else { setStateOther(false); setCityOther(false); onState(e.target.value); onCity(""); }
          }} className={cls}>
          <option value="">Select State</option>
          {states.map((s) => <option key={s} value={s}>{s}</option>)}
          <option value={OTHER}>Other (add manually)</option>
        </select>
        {stateOther && <input data-testid="addr-state-other" value={state} onChange={(e) => onState(e.target.value)} placeholder="Enter state" className={cls} />}
      </div>

      <div className="space-y-2">
        {cityOther || stateOther ? (
          <input data-testid="addr-city-other" value={city} onChange={(e) => onCity(e.target.value)} placeholder="Enter city" className={cls} />
        ) : (
          <select data-testid="addr-city" value={city} onChange={(e) => { if (e.target.value === OTHER) { setCityOther(true); onCity(""); } else onCity(e.target.value); }} disabled={!state} className={cls}>
            <option value="">{state ? "Select City" : "Select state first"}</option>
            {cities.map((c) => <option key={c} value={c}>{c}</option>)}
            {state && <option value={OTHER}>Other (add manually)</option>}
          </select>
        )}
      </div>
    </>
  );
}
